<div class="c-modal-material c-modal--confirm">
  <div class="c-modal__body">
    <p>{{ 'HIPAA-CONSENT.pre_therapy_onboarding_wall_additional_information_required_dialog' | translate }}</p>
  </div>
  <div class="c-modal__footer">
    <div class="o-layout o-layout--auto@tablet">
      <div class="o-layout__item">
        <button class="c-btn c-btn--primary" type="button" (click)="onContinue()">
          {{ 'ACCEPT-POLICIES.Continue' | translate }}
        </button>
      </div>
      <div class="o-layout__item">
        <button class="c-btn c-btn--tertiary" type="button" (click)="onLogout()">
          {{ 'HEADER.SignOut' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
